<table class="desktopTable">
	<tbody>
		<tr class="thead bg-primary text-white font-medium">
			<th class="text-left pl-7">QTY</th>
			<th class="text-left">ORDER ID</th>
			<th class="text-left">DESCRIPTION</th>
			<th class="desktopTable__priceCol text-left pr-7">PRICE</th>
		</tr>
		<tr *ngFor="let item of order.orderItems">
			<td class="pl-7">{{ item.quantity }}</td>
			<td>{{order.name}}</td>
			<td class="ion-text-right desktopTable__productName">
				{{ item.productName }}
			</td>
			<td class="pl-7">
				{{ item.productPrice | currency: "USD":"symbol-narrow":".2-2" }}
			</td>
		</tr>
		<!-- Upsell information -->
		<ng-container *ngIf="orderReceipt.upsells && orderReceipt.upsells.length">
			<ng-container *ngFor="let upsell of orderReceipt.upsells">
			  <tr *ngFor="let orderItem of upsell.orderItems">
				<td class="pl-7">
				  {{ orderItem.quantity }}
				</td>
				<td>
				  {{ upsell.name }}
				</td>
				<td class="ion-text-right desktopTable__productName">
				  {{ orderItem.productName }}
				</td>
				<td class="pl-7">
				  {{ orderItem.productPrice | currency: "USD":"symbol-narrow":".2-2" }}
				</td>
			  </tr>
			</ng-container>
		</ng-container>
		<!-- End of upsell information -->
	</tbody>
</table>

<div class="summary">
	<div class="tax">
		<span>Tax:</span>
		<span>
			{{ order.tax + upsellsTotalTax | currency: "USD":"symbol-narrow":".2-2" }}
		</span>
	</div>
	<div class="shipping">
		<span>Shipping:</span>
		<span>
			{{ order.orderShippingCost + upsellsShippingCost | currency: "USD":"symbol-narrow":".2-2" }}
		</span>
	</div>
	<div class="total">
		<span class="font-bold">TOTAL:</span>
		<span class="font-bold">
			{{ order.total + upsellsTotal | currency: "USD":"symbol-narrow":".2-2" }}
		</span>
	</div>
</div>

<div class="mobileTable">
	<div *ngFor="let item of order.orderItems"
		class="item">
		<div class="flex">
			<p>QTY</p>
			<span>{{ item.quantity }}</span>
		</div>
		<div class="flex">
			<p>ORDER ID</p>
			<span>{{order.name}}</span>
		</div>
		<div class="flex">
			<p>DESCRIPTION</p>
			<span>
				{{ item.productName }}
			</span>
		</div>
		<div class="flex">
			<p>PRICE</p>
			<span>
				{{ item.productPrice | currency: "USD":"symbol-narrow":".2-2" }}
			</span>
		</div>
	</div>

	<!-- Upsell information -->
	<ng-container *ngIf="orderReceipt.upsells && orderReceipt.upsells.length">
		<ng-container *ngFor="let upsell of orderReceipt.upsells">
		  <div *ngFor="let orderItem of upsell.orderItems"
			class="item">
			<div class="flex">
				<p>QTY</p>
				<span>{{ orderItem.quantity }}</span>
			</div>
			<div class="flex">
				<p>ORDER ID</p>
				<span>{{upsell.name}}</span>
			</div>
			<div class="flex">
				<p>DESCRIPTION</p>
				<span class="desktopTable__productName">
					{{ orderItem.productName }}
				</span>
			</div>
			<div class="flex">
				<p>PRICE</p>
				<span>
					{{ orderItem.productPrice | currency: "USD":"symbol-narrow":".2-2" }}
				</span>
			</div>
		</div>

		</ng-container>
	</ng-container>
	<!-- End of upsell information -->

	<div class="item">
		<div class="flex">
			<p class="min-w-32 w-32">Tax:</p>
			<span>
				{{ order.tax + upsellsTotalTax | currency: "USD":"symbol-narrow":".2-2" }}
			</span>
		</div>
		<div class="flex">
			<p class="min-w-32 w-32">Shipping:</p>
			<span>
				{{ order.orderShippingCost + upsellsShippingCost | currency: "USD":"symbol-narrow":".2-2" }}
			</span>
		</div>
		<div class="flex">
			<p class="min-w-32 w-32 font-semibold">TOTAL:</p>
			<span class="font-semibold">
				{{ order.total + upsellsTotal | currency: "USD":"symbol-narrow":".2-2" }}
			</span>
		</div>
	</div>
</div>
